import config from '../../../constants/config';

// Bing Tracking Pixel
if (
  Array.isArray(config.BING_TRACKING_PIXEL) &&
  config.BING_TRACKING_PIXEL.length > 0
) {
  for (let index = 0; index < config.BING_TRACKING_PIXEL.length; index++) {
    const bingId = config.BING_TRACKING_PIXEL[index];
    const tag = index === 0 ? 'uetq' : `uetq${index + 1}`;

    /* eslint-disable */
    (function (w, d, t, r, u) {
      var f, n, i;
      (w[u] = w[u] || []),
        (f = function () {
          var o = {
            ti: bingId,
            enableAutoSpaTracking: true,
          };
          (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
        }),
        (n = d.createElement(t)),
        (n.src = r),
        (n.defer = 1),
        (n.onload = n.onreadystatechange =
          function () {
            var s = this.readyState;
            (s && s !== 'loaded' && s !== 'complete') ||
              (f(), (n.onload = n.onreadystatechange = null));
          }),
        (i = d.getElementsByTagName(t)[0]),
        i.parentNode.insertBefore(n, i);
    })(window, document, 'script', '//bat.bing.com/bat.js', tag);
    /* eslint-enable */
  }
}



// WEBPACK FOOTER //
// ./src/assets/helpers/scripts/bing.js